'use client'

import React, { useState } from 'react'
import { Menu } from 'lucide-react'
import { Sheet, SheetContent, SheetTrigger, SheetClose } from '@/components/ui/sheet'
import { Logo } from '@/components/logo'
import { CMSLink } from '@/components/link'
import type { CMSLinkType } from '@/components/link'
import { Separator } from '@/components/ui/separator'
import { SearchIcon, X } from 'lucide-react'
import Link from 'next/link'
import { ScrollArea } from '@/components/ui/scroll-area'

import type { Header as HeaderType } from '@payload-types'
import type { Media as MediaType } from '@payload-types'

interface MobileMenuProps {
  data: HeaderType
}

export const MobileMenu: React.FC<MobileMenuProps> = ({ data }) => {
  const navItems = data?.nav?.navItems || []
  const specialNavItems = data?.['special-nav']?.specialNavItems || []
  const socialLinks = data?.['special-nav']?.socialLinks || []
  const [open, setOpen] = useState(false)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger className="md:hidden flex items-center justify-center">
        <Menu className="h-6 w-6" />
        <span className="sr-only">Menüyü aç/kapat</span>
      </SheetTrigger>
      <SheetContent side="left" className="flex flex-col p-6">
        <div className="flex items-center justify-between mb-8">
          <Logo loading="eager" priority="high" />
        </div>

        <div className="space-y-6 flex-1">
          <div className="space-y-2 flex flex-col justify-start">
            <h4 className="text-sm font-medium ml-2">Menü</h4>
            <Separator />
            <ScrollArea className="h-[calc(100vh-12rem)]">
              <nav className="flex flex-col justify-start space-y-4">
                {navItems.map(({ link }, i) => (
                  <div key={i} className="w-full" onClick={() => setOpen(false)}>
                    <CMSLink
                      {...(link as any)}
                      appearance="link"
                      className="text-base sm:text-lg text-foreground hover:text-muted-foreground transition-colors font-medium block w-full text-left"
                    />
                  </div>
                ))}
              </nav>
            </ScrollArea>
          </div>

          <div className="mt-auto pt-4">
            <div onClick={() => setOpen(false)}>
              <Link
                href="/arama"
                className="flex items-center space-x-2 text-muted-foreground hover:text-foreground transition-colors text-base sm:text-lg"
              >
                <SearchIcon className="h-5 w-5 sm:h-6 sm:w-6" />
                <span>Ara</span>
              </Link>
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  )
}
